import AuthSocialIframeForm from "./AuthSocialIframeForm";

export default AuthSocialIframeForm;
